import { FC } from 'react';
import { Container, Section } from '../components/Base';
import { BetaFeedbackForm } from '../components/BetaFeedback/BetaFeedbackForm';
import { RequireSignIn } from '../components/RequireSignIn';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type BetaFeedbackPageProps = {};

export const BetaFeedbackPage: FC<BetaFeedbackPageProps> = () => (
  <Section>
    <Container>
      <div className="gfp-row">
        <div className="col-8 offset-2">
          <h1>GoFullPage BETA feedback</h1>
          {/* <p className="large">
            Tell us how specific beta features are working for you.
          </p> */}
          <RequireSignIn>
            {({ account }) => <BetaFeedbackForm account={account} />}
          </RequireSignIn>
        </div>
      </div>
    </Container>
  </Section>
);
